'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var NoStyleButton_web = require('../../../atoms/NoStyleButton/NoStyleButton.web.cjs');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var InternalBadge_web = require('../../../internal/InternalBadge/InternalBadge.web.cjs');
require('../../../../../../../_virtual/index.cjs');
require('react');
require('@remix-run/react');
require('react-router-dom');
require('../../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../../../internal/InternalToggle/InternalToggle.web.cjs');
var Item_web_styles = require('../Item/Item.web.styles.cjs');
var ChipContext = require('../context/ChipContext.cjs');

/**
 * A component that allows the user to show more items in a chip group
 * @note This is used internally by the Chip.Filter component to show more items when the number of items exceeds the `maxVisible` prop
 */ const ShowMore = ({ customCss, onClick, expanded, ...props })=>{
    const theme = react.useTheme();
    const { variant, hiddenCount } = ChipContext.useChipContext();
    const chipStyles = [
        Item_web_styles.chipItemBase,
        Item_web_styles.chipVariant[variant](theme, false),
        customCss
    ];
    return /*#__PURE__*/ jsxRuntime.jsxs(NoStyleButton_web.NoStyleButton, {
        type: "button",
        customCss: chipStyles,
        onClick: onClick,
        ...props,
        children: [
            expanded ? /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                icon: index.faChevronLeft,
                css: Item_web_styles.chipIcon
            }) : /*#__PURE__*/ jsxRuntime.jsxs(InternalBadge_web.InternalBadge, {
                children: [
                    "+",
                    hiddenCount
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                variant: "footnote",
                fontWeight: "bold",
                isTruncated: true,
                isMarginless: true,
                as: "span",
                customCss: Item_web_styles.chipItemText(theme, false),
                children: expanded ? "Show less" : "Show all"
            })
        ]
    });
};
ShowMore.displayName = "Chip.ShowMore";

exports.ShowMore = ShowMore;
//# sourceMappingURL=ShowMore.web.cjs.map
